/**
 * Corrosion Analyser Dashboard - Data Grid Headers Configuration
 *
 * Defines the column headers for the Corrosion Analyser grid that displays
 * AVA-Inspect tags filtered for corrosion-related defects.
 *
 */

export default [
  {
    text: 'Actions',
    value: 'actions',
    sortable: false,
    width: 200,
  },
  {
    text: '',
    value: 'thumbnailUrl',
    sortable: false,
    width: 100,
  },
  {
    text: 'Tag ID',
    value: 'name',
    sortable: true,
    width: 250
  },
  {
    text: 'Master Tag',
    value: 'masterTagName',
    sortable: true,
    width: 180
  },
  {
    text: 'Title',
    value: 'title',
    sortable: true,
    width: 200
  },
  {
    text: 'Max Distance',
    value: 'maxDistance',
    sortable: false,
    width: 120,
  },
  {
    text: 'Predicted WT Loss',
    value: 'predictedWtLoss',
    sortable: false,
    width: 200,
  },
  {
    text: 'Category',
    value: 'categoryName',
    sortable: false,
    width: 130,
  },
  // {
  //   text: 'Analysis',
  //   value: 'heatMapUrl',
  //   sortable: false,
  //   width: 110,
  // },
  {
    text: 'Status',
    value: 'status',
    sortable: true,
    width: 130,
  },
  {
    text: 'Priority',
    value: 'priority',
    sortable: true,
    width: 120
  },
];
